/**
 * @generated by @interxfi/j5-codegen - do not edit */

import { buildMergedRequestInit, makeRequest } from '@interxfi/api-client/request';
import type { IxcSweepsV1SweepPlanQueryServiceSweepPlanListResponse, IxcSweepsV1SweepPlanQueryServiceSweepPlanListSweepPlanListRequest } from '@interxfi/types';

export const IXC_SWEEPS_V1_SWEEP_PLAN_QUERY_SERVICE_SWEEP_PLAN_LIST_AUDIENCE = ['clearing', 'program'];

export async function ixcSweepsV1SweepPlanQueryServiceSweepPlanList(baseUrl: string | undefined, request?: IxcSweepsV1SweepPlanQueryServiceSweepPlanListSweepPlanListRequest, requestInit?: RequestInit): Promise<IxcSweepsV1SweepPlanQueryServiceSweepPlanListResponse | undefined> { return makeRequest<IxcSweepsV1SweepPlanQueryServiceSweepPlanListResponse, IxcSweepsV1SweepPlanQueryServiceSweepPlanListSweepPlanListRequest>(...buildMergedRequestInit('GET', baseUrl || '', '/ixc/sweeps/v1/sweep_plan/q', request, requestInit)); }

